(() => {
	const categoriesList = () => {
		const categoriesSection = document.querySelector(".categories-list");
		const categoriesItems = document.querySelectorAll(
			".categories-list__item-inner",
		);
		const resizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			if (entry.contentRect.width > 1200) {
				categoriesItems.forEach((item) => {
					item.addEventListener("mouseover", () => {
						item.classList.remove(`${item.getAttribute("data-base")}`);
						item.classList.add(`${item.getAttribute("data-hover")}`);
						if (item.querySelector("video")) item.querySelector("video").play();
					});
					item.addEventListener("mouseout", () => {
						item.classList.remove(`${item.getAttribute("data-hover")}`);
						item.classList.add(`${item.getAttribute("data-base")}`);
						if (item.querySelector("video")) item.querySelector("video").pause();
					});
				});
			}
		});
		resizeObserver.observe(categoriesSection);

		const stopVideo = () => {
			const videos = categoriesSection.querySelectorAll("video");
			if (videos.length > 0) {
				videos.forEach((video) => {
					video.pause();
				});
			}
		};

		stopVideo();
	};
	const categoriesSlider = () => {
        const sliders = document.querySelectorAll('.categories-container--slider');
        sliders.forEach((slider, index) => {

          const parent = slider.closest('.categories-list__wrapper--slider ');
		  const nextArrow = slider.querySelector(".next");
		  const prevArrow = slider.querySelector(".prev");

		  const initSlider = () => {
			articlesSlider = new Swiper(slider, {
				slidesPerView: '1.2',
				spaceBetween: 8,
	
				breakpoints: {
				  576: {
					// slidesPerView: 2.05,
					// slidesPerGroup: 2
				  },
				  990: {
					// slidesPerView: 3.05,
					// slidesPerGroup: 3
				  },
				  1200: {
					slidesPerView: 3,
				  },
				  1441: {
					slidesPerView: 'auto',
				  }
				}
			});
		  };
		    // Initialize the slider on page load
			initSlider();

			// Add resize event listener to update the slider when the screen is resized
			window.addEventListener("resize", () => {
			  initSlider();
			});
        })
    }

	categoriesList();
	categoriesSlider();

	document.addEventListener("shopify:section:load", categoriesList);
	document.addEventListener("shopify:section:load", categoriesSlider());
})();
